import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { Visibility as VisibilityIcon } from '@mui/icons-material';

const DetailCellRenderer = ({ data, onViewDetails }) => {
    const handleClick = () => {
        if (onViewDetails) {
            onViewDetails(data);
        }
    };

    return (
        <Box display="flex" alignItems="center" justifyContent="center" height="100%">
            <Tooltip title="View full details">
                <IconButton size="small" onClick={handleClick}>
                    <VisibilityIcon fontSize="small" />
                </IconButton>
            </Tooltip>
        </Box>
    );
};

export default DetailCellRenderer;
